// CC_RESPONDI_WEBAPP (2026-09-29, pedido do usuario: "crie o web app do respondi"): botao "Instalar app"
// no topo. Some quando ja esta instalado (aberto como app). Android/computador: janela nativa de
// instalacao (evento beforeinstallprompt, capturado cedo em src/index.js). iPhone: so o Safari
// instala -- mostra os passos. Aberto de dentro do WhatsApp/Instagram/Facebook (navegador embutido
// nao instala): no Android reabre no Chrome; no iPhone orienta abrir no Safari.
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import InstallMobileIcon from "@mui/icons-material/InstallMobile";

const isStandalone = () =>
  (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) || window.navigator.standalone === true;

export default function InstallAppButton() {
  const [installed, setInstalled] = useState(isStandalone());
  const [help, setHelp] = useState(null); // texto das instrucoes

  useEffect(() => {
    const onInstalled = () => setInstalled(true);
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);

  if (installed) return null;

  const handleClick = async () => {
    const ua = navigator.userAgent || "";
    const isIOS = /iphone|ipad|ipod/i.test(ua);
    const inApp = /FBAN|FBAV|FB_IAB|Instagram|WhatsApp|Line\/|; wv\)/i.test(ua);
    const prompt = window.__ccInstallPrompt;
    if (prompt) {
      prompt.prompt();
      try { const r = await prompt.userChoice; if (r && r.outcome === "accepted") setInstalled(true); } catch (e) {}
      window.__ccInstallPrompt = null;
      return;
    }
    if (inApp && /android/i.test(ua)) {
      window.location.href = "intent://" + window.location.host + "/tickets#Intent;scheme=https;package=com.android.chrome;end";
      return;
    }
    if (isIOS) {
      setHelp(inApp
        ? ["Abra este endereço no Safari (menu … → \"Abrir no Safari\").", "No Safari, toque em Compartilhar (↑).", "Escolha \"Adicionar à Tela de Início\"."]
        : ["Toque em Compartilhar (↑) na barra do Safari.", "Escolha \"Adicionar à Tela de Início\".", "Toque em \"Adicionar\"."]);
      return;
    }
    setHelp(["Abra o menu do navegador (⋮ no Chrome, ou o ícone de instalar ⊕ na barra de endereço).", "Escolha \"Instalar Respondi\" ou \"Adicionar à tela inicial\".", "Confirme em \"Instalar\"."]);
  };

  return (
    <>
      <Tooltip title="Instalar app">
        <IconButton color="inherit" onClick={handleClick} aria-label="Instalar app">
          <InstallMobileIcon />
        </IconButton>
      </Tooltip>
      <Dialog open={!!help} onClose={() => setHelp(null)} maxWidth="xs" fullWidth>
        <DialogTitle>Instalar a Respondi</DialogTitle>
        <DialogContent>
          {(help || []).map((p, i) => (
            <Typography key={i} sx={{ mb: 1.2 }}><b>{i + 1}.</b> {p}</Typography>
          ))}
        </DialogContent>
        <DialogActions><Button onClick={() => setHelp(null)}>Entendi</Button></DialogActions>
      </Dialog>
    </>
  );
}
